export default __webpack_public_path__ + "static/3-187368893802ba1dcae33e5ce21436dc.png";